var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,7 C18,3.13 14.87,0 11,0 C7.78,0 5.07,2.18 4.26,5.15 C1.82,5.71 0,7.89 0,10.5 C0,13.54 2.46,16 5.5,16 C7.26,16 15.75,16 17.5,16 L17.5,16 C19.99,15.99 22,13.97 22,11.48 C22,9.15 20.25,7.26 18,7 Z M12,9 L12,11 C12,11.55 11.55,12 11,12 L11,12 C10.45,12 10,11.55 10,11 L10,9 L8.21,9 C7.76,9 7.54,8.46 7.86,8.15 L10.65,5.36 C10.85,5.16 11.16,5.16 11.36,5.36 L14.15,8.15 C14.46,8.46 14.24,9 13.8,9 L12,9 L12,9 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c2bc90fffc55e112013a55416a057de2.svg";
export { ForwardRef as ReactComponent };